export class Facturacion{
	constructor(
		public id: number, 
		public grupo_empresa_id: number,
		public razon_social: string,
		public rfc: string,
		public direccion: string,
		public no_interior: string,
		public no_exterior: string,
		public cp: string,
		public colonia: string,
		public ciudad: string,
		public method: string
	){}
}